module.exports = __webpack_public_path__ + "static/media/playlist-reorder.0baccff9.svg";